import { Component, Input, OnChanges } from '@angular/core';
import { AdherentService } from '../service/adherent.service';
import { RoleNavigationMarinEnum, TypeAdherentEnum, TypeDossierEnum } from '../constant/enum';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Adherent, IAdherent } from '../model/adherent.model';
import { convertToHumanDate } from '../util/moment.utils';
import { IAdherentInformations } from '../model/adherent-informations.model';
import { filterOkMapBody } from '../util/http.utils';
import { ICamp } from '../model/camp.model';
import { IProjetAnnee } from '../model/projet-annee.model';
import { SnackBarService } from '../service/snackbar.service';
import { ROLES_ACTIVITE_NAVIGATION } from '../constant/constant';
import { getAdherentDiplomesMarin, getAdherentDiplomesMarinLabel } from '../util/adherent-utils'
import {
  CampModuleMarinEncadrantNautique,
  ICampModuleMarinEncadrantNautique
} from '../model/camp-module-marin-encadrant-nautique.model';
import {
  IProjetAnneeModuleMarinEncadrantNautique,
  ProjetAnneeModuleMarinEncadrantNautique
} from '../model/projet-annee-module-marin-encadrant-nautique.model';
import { checkCodeEntry } from "../util/form-validator.utils";
import { StructureService } from "../service/structure.service";
import { CampAdherentParticipant, ICampAdherentParticipant } from "../model/camp-adherent-participant.model";
import moment from "moment";

@Component({
    selector: 'ddc-module-marin-staff-selector',
    templateUrl: './module-marin-encadrant-nautique-selector.component.html',
    styleUrls: ['./module-marin-encadrant-nautique-selector.component.scss'],
    standalone: false
})
export class ModuleMarinEncadrantNautiqueSelectorComponent implements OnChanges {

  @Input() set adherentsDisponibles(adherentsDisponibles: IAdherent[]) {
    this._adherentsDisponibles = adherentsDisponibles;
  }

  @Input() set encadrantsNautiquesFormArray(encadrantsNautiquesFormArray: FormArray) {
    this._encadrantsNautiquesFormArray = encadrantsNautiquesFormArray;
  }

  @Input() set typeDossier(typeDossier: TypeDossierEnum) {
    this._typeDossier = typeDossier;
  }

  @Input() set isSaving(isSaving: boolean) {
    this._isSaving = isSaving;
  }

  @Input() set currentCamp(currentCamp: ICamp) {
    this._currentCamp = currentCamp;
  }

  @Input() set campFormPatchValue(campFormPatchValue: ICamp) {
    this._campFormPatchValue = campFormPatchValue;
  }

  @Input() set projetAnneeFormPatchValue(projetAnneeFormPatchValue: IProjetAnnee) {
    this._projetAnneeFormPatchValue = projetAnneeFormPatchValue;
  }

  @Input() set currentProjetAnnee(currentProjetAnnee: IProjetAnnee) {
    this._currentProjetAnnee = currentProjetAnnee;
  }

  codeEntryForm = this.fb.group({
    structure: ['', [checkCodeEntry]],
  });

  codeAdherentEntryForm = this.fb.group({
    participant: ['', [checkCodeEntry]]
  });

  _adherentsDisponibles: IAdherent[] = [];
  _encadrantsNautiquesFormArray: FormArray;
  _typeDossier: TypeDossierEnum;
  _isSaving: boolean;
  _currentCamp: ICamp;
  _campFormPatchValue: ICamp;
  _currentProjetAnnee: IProjetAnnee;
  _projetAnneeFormPatchValue: IProjetAnnee;

  adherentsDisponiblesTableDataSource = new MatTableDataSource<IAdherent>([]);
  adherentsDisponiblesTableDisplayedColumns = ['prenomNom', 'ajouter'];

  encadrantsNautiquesTableDataSource = new MatTableDataSource<AbstractControl>([]);
  ddcEncadrantsNautiquesTableDisplayedColumns = ['roleNavigationMarin', 'prenomNom', 'diplome', 'supprimer'];
  ddcEncadrantsNautiquesTableDisplayedColumnsForProjetAnnee = ['prenomNom', 'diplome', 'supprimer'];

  adherentDiplomesTableDisplayedComumns = ['type', 'dateObtention'];

  adherentsInformations: IAdherentInformations[] = [];

  encadrantNautiqueSelectionneFormGroup: FormGroup;

  ROLES_ACTIVITE_NAVIGATION = ROLES_ACTIVITE_NAVIGATION;
  convertToHumanDate = convertToHumanDate;
  getAdherentDiplomesMarin = getAdherentDiplomesMarin;
  getAdherentDiplomesMarinLabel = getAdherentDiplomesMarinLabel;
  TypeDossierEnum = TypeDossierEnum;
  TypeAdherentEnum = TypeAdherentEnum;
  numeroAdherentSelectionne: number;

  constructor(
    protected adherentService: AdherentService,
    protected snackBarService: SnackBarService,
    protected fb: FormBuilder,
    protected structureService: StructureService
  ) {
  }

  ngOnChanges() {
    this.initAdherentsDisponiblesTableData();
    this.initDdcModuleMarinEncadrantsNautiquesTableData(this.getDdcModuleMarinEncadrantsNautiquesFormArray());
    this.initAdherentsInformations(this.getDdcModuleMarinEncadrantsNautiquesFormArray());
    this.encadrantNautiqueSelectionneFormGroup = null;
  }

  private initAdherentsDisponiblesTableData() {
    const ddcModuleMarinEncadrantsNautiqueNumeros = new Set<string>(this.getDdcModuleMarinEncadrantsNautiquesFormArray().getRawValue().map(ddcModuleMarinEncadrantNaqutique => ddcModuleMarinEncadrantNaqutique.adherent.numero));
    this.adherentsDisponiblesTableDataSource.data = this._adherentsDisponibles.filter(adherent => !ddcModuleMarinEncadrantsNautiqueNumeros.has(adherent.numero));
  }

  private initDdcModuleMarinEncadrantsNautiquesTableData(ddcModuleMarinEncadrantsNautiquesFormArray: FormArray) {
    this.encadrantsNautiquesTableDataSource.data = ddcModuleMarinEncadrantsNautiquesFormArray ? ddcModuleMarinEncadrantsNautiquesFormArray.controls : [];
  }

  private getDdcModuleMarinEncadrantsNautiquesFormArray(): FormArray {
    return this._encadrantsNautiquesFormArray as FormArray;
  }

  private createCampModuleMarinEncadrantNautiqueFormGroup(campModuleMarinEncadrantNautique) {
    const formGroup = this.fb.group(new CampModuleMarinEncadrantNautique());
    formGroup.controls.roleNavigationMarin.setValidators(Validators.required);
    formGroup.patchValue(campModuleMarinEncadrantNautique);
    return formGroup;
  }

  private createProjetAnneeModuleMarinEncadrantNautiqueFormGroup(projetAnneeModuleMarinEncadrantNautique: IProjetAnneeModuleMarinEncadrantNautique) {
    const formGroup = this.fb.group(new ProjetAnneeModuleMarinEncadrantNautique());
    formGroup.controls.roleNavigationMarin.setValidators(Validators.required);
    formGroup.patchValue(projetAnneeModuleMarinEncadrantNautique);
    return formGroup;
  }

  initAdherentsInformations(ddcModuleMarinEncadrantsNautiquesFormArray: FormArray) {

    const adherents: IAdherent[] = ddcModuleMarinEncadrantsNautiquesFormArray.getRawValue().map(
      (ddcModuleMarinEncadrantNautique: ICampModuleMarinEncadrantNautique|IProjetAnneeModuleMarinEncadrantNautique) => ddcModuleMarinEncadrantNautique.adherent
    );

    let codesAdherent: string[] = [];
    let idCamp: number;

    // Retreive the information of the adherents
    let ddcStaffAdherentsInformations: IAdherentInformations[] = [];
    if (this._typeDossier === TypeDossierEnum.CAMP && this._currentCamp && this._currentCamp.campAdherentStaffsInformations) {
      ddcStaffAdherentsInformations = this._currentCamp.campAdherentStaffsInformations;
    }else if(this._typeDossier === TypeDossierEnum.PROJET_ANNEE && this._currentProjetAnnee && this._currentProjetAnnee.projetAnneeAdherentStaffsInformations) {
      ddcStaffAdherentsInformations = this._currentProjetAnnee.projetAnneeAdherentStaffsInformations;
    }

    if(ddcStaffAdherentsInformations && ddcStaffAdherentsInformations.length > 0) {
      ddcStaffAdherentsInformations.forEach((ddcStaffAdherentInformations: IAdherentInformations) => {
        this.adherentsInformations[ddcStaffAdherentInformations.numero] = ddcStaffAdherentInformations;
      });
    }

    // Check missing adherent informations (The ones who are not saved in database, but in localstorage 'cache')
    if(adherents && adherents.length > 0) {
      adherents.forEach((adherent: IAdherent) => {
        if(!this.adherentsInformations[adherent.numero]) {
          codesAdherent.push(adherent.numero)
        }
      });
      if(codesAdherent && codesAdherent.length > 0) {
        idCamp = this._typeDossier === TypeDossierEnum.CAMP ? this._currentCamp.id : null;
        this.adherentService.getAdherentsInformations(codesAdherent, this._typeDossier, idCamp)
          .pipe(filterOkMapBody)
          .subscribe((adherentsInformations: IAdherentInformations[]) => {
            if(adherentsInformations && adherentsInformations.length > 0) {
              adherentsInformations.forEach((adherentInformations: IAdherentInformations) => {
                this.adherentsInformations[adherentInformations.numero] = adherentInformations;
              });
            }
          });
      }
    }
  }

  setAdherentInformations(adherent: Adherent) {
    if(adherent && adherent.numero && !this.adherentsInformations[adherent.numero]) {
      const idCamp = this._typeDossier === TypeDossierEnum.CAMP ? this._currentCamp.id : null;
      this.adherentService.getAdherentInformations(adherent.numero, this._typeDossier, idCamp)
        .pipe(filterOkMapBody)
        .subscribe((adherentInformation: IAdherentInformations) => {
          this.adherentsInformations[adherent.numero] = adherentInformation;
        });
    }
  }

  ajouterAdherentDisponibleSelectionne(index: number) {
    const adherent = this.adherentsDisponiblesTableDataSource.data[index];
    const encadrantsNautiquesAdherentsCodes = new Set<string>(this.getDdcModuleMarinEncadrantsNautiquesFormArray().getRawValue().map((encadrantNautique: ICampModuleMarinEncadrantNautique) => encadrantNautique.adherent.numero));
    const presenceFlag = encadrantsNautiquesAdherentsCodes.has(adherent.numero);
    if(!presenceFlag) {
      this.createDdcModuleMarinEncadrantNautique(adherent);
    }else {
      this.snackBarService.showError("L\'adhérent est déjà ajouté");
    }
  }

  createDdcModuleMarinEncadrantNautique(adherent: IAdherent) {
    const encadrantsNautiquesFormArray = this.getDdcModuleMarinEncadrantsNautiquesFormArray();
    if(this._typeDossier === TypeDossierEnum.CAMP) {
      const encadrantNautique = new CampModuleMarinEncadrantNautique();
      encadrantNautique.id = 0;
      encadrantNautique.adherent = adherent;
      encadrantNautique.roleNavigationMarin = RoleNavigationMarinEnum.CHEF_BORD;
      encadrantsNautiquesFormArray.push(this.createCampModuleMarinEncadrantNautiqueFormGroup(encadrantNautique));
    }else if(this._typeDossier === TypeDossierEnum.PROJET_ANNEE) {
      const encadrantNautique = new ProjetAnneeModuleMarinEncadrantNautique();
      encadrantNautique.id = 0;
      encadrantNautique.adherent = adherent;
      encadrantNautique.roleNavigationMarin = RoleNavigationMarinEnum.CHEF_BORD;
      encadrantsNautiquesFormArray.push(this.createProjetAnneeModuleMarinEncadrantNautiqueFormGroup(encadrantNautique));
    }
    // On ré-initialise la liste des adhérents disponibles
    this.setAdherentInformations(adherent);
    this.initAdherentsDisponiblesTableData();
    this.initDdcModuleMarinEncadrantsNautiquesTableData(encadrantsNautiquesFormArray);
  }

  selectionnerDdcModuleMarinEncadrantNautique(row: FormGroup) {
    const selectedAdherent: IAdherent = row.get('adherent') ? row.get('adherent').value : undefined;
    this.numeroAdherentSelectionne = selectedAdherent.numero ? parseInt(selectedAdherent.numero, 10) : undefined;
    this.encadrantNautiqueSelectionneFormGroup = row;
    this.encadrantNautiqueSelectionneFormGroup.markAllAsTouched();
  }

  supprimerDdcModuleMarinEncadrantNautiqueSelectionne(index: number) {
    const staffsFormArray = this.getDdcModuleMarinEncadrantsNautiquesFormArray();
    staffsFormArray.removeAt(index);
    this.initAdherentsDisponiblesTableData();
    this.initDdcModuleMarinEncadrantsNautiquesTableData(staffsFormArray);
    this.encadrantNautiqueSelectionneFormGroup = null;
  }

  getDdcModuleMarinEncadrantNautiqueIcon(roleNavigationMarin: string) {
    const role = ROLES_ACTIVITE_NAVIGATION.find(role => role.value == roleNavigationMarin);
    return role ?  role :  null;
  }

  disableCodeSubmitButton(control: AbstractControl) {
    const value = control.value;
    if (value === '' || value === undefined || value === null ||
      (control.errors && control.errors.invalid === true)) {
      return true;
    } else {
      return false;
    }
  }

  public addParticipantByCodeEntry(adherentType?: string) {
    const codeAdherent = this.codeAdherentEntryForm.get('participant').value;
    const codeGroupeCamp = this.currentCamp && this.currentCamp.typeCamp ? this.currentCamp.typeCamp.codeGroupeCamp : null;
    this.adherentService.findByNumero(codeAdherent, adherentType, codeGroupeCamp)
      .pipe(filterOkMapBody)
      .subscribe((adherent: IAdherent) => {
          if (adherent) {
            const campAdherentParticipantsCodes = new Set<string>(this.getDdcModuleMarinEncadrantsNautiquesFormArray().getRawValue().map((campAdherentParticipant: ICampAdherentParticipant) => campAdherentParticipant.adherent.numero));
            const presenceFlag = campAdherentParticipantsCodes.has(adherent.numero);
            if (!presenceFlag) {
              const participantsFormArray = this.getDdcModuleMarinEncadrantsNautiquesFormArray();
              const campAdherentParticipant = new CampAdherentParticipant();
              campAdherentParticipant.adherent = adherent;
              campAdherentParticipant.id = 0;
              campAdherentParticipant.chefEquipe = false;

              // Par défaut on met comme date de début et de fin de présence celles du camp
              if (this._typeDossier == TypeDossierEnum.CAMP) {
                campAdherentParticipant.dateDebutPresence = this.currentCamp.dateDebut;
                campAdherentParticipant.dateFinPresence = this.currentCamp.dateFin;
              } else {
                campAdherentParticipant.dateDebutPresence = moment();
                campAdherentParticipant.dateFinPresence = moment();
              }
              participantsFormArray.push(this.createCampAdherentParticipantFormGroup(campAdherentParticipant));

              // On ré-initialise la liste des adhérents disponibles
              this.initAdherentsDisponiblesTableData();
              this.initDdcModuleMarinEncadrantsNautiquesTableData(participantsFormArray);
            } else {
              this.codeEntryForm.get('participant').setErrors({errorMessage: 'L\'adhérent est déjà ajouté'});
            }
          } else {
            this.codeAdherentEntryForm.get('participant').setErrors({errorMessage: 'Le code adherent que vous avez saisi est inconnu'});
          }
        },
        (err) => {
          if (err && err.status === 404) {
            this.codeAdherentEntryForm.get('participant').setErrors({errorMessage: 'Le code adherent que vous avez saisi est inconnu'});
          } else if (err && err.error && err.error.message) {
            this.snackBarService.showError(err.error.message);
          }
        });
  }

  private createCampAdherentParticipantFormGroup(campAdherentParticipant) {
    const formGroup = this.fb.group(new CampAdherentParticipant());
    formGroup.controls.dateDebutPresence.setValidators(Validators.required);
    formGroup.controls.dateFinPresence.setValidators(Validators.required);
   // formGroup.setValidators(checkDates('dateDebutPresence', 'dateFinPresence', [this.currentCamp.dateDebut, this.currentCamp.dateFin], 'Choisissez une date qui appartient à la date du camp'));
    formGroup.patchValue(campAdherentParticipant);
    return formGroup;
  }
}
